<template>
  <Transition name="fade">
    <div
      v-if="isSatelliteInfo" class="info_box"
      :class="{'user' : accessedMemberInfo.name, 'tracking_mode' : satelliteInfo.isCurrentTrackingSat}"
    >
      <template v-if="!accessedMemberInfo.name">
        <h2 class="info_box_title">
          HELLO THERE
        </h2>
        <div class="satellite_info_box">
          {{ getSatelliteName() }}
        </div>
      </template>
      <template v-else>
        <div class="satellite_info_box">
          {{ getSatelliteName() }}'s OREUM SAT
        </div>
        <h2 class="info_box_title">
          HELLO {{ getLevelName() }}
        </h2>
      </template>
      <div class="area_info_list">
        <div>
          <div class="lat">
            {{ getCoordinate("Lat") }}N
          </div>
          <div class="lon">
            {{ getCoordinate("Lon") }}E
          </div>
          <div class="country">
            {{ getCountryName }}
          </div>
        </div>
      </div>
      <img
        v-if="accessedMemberInfo.name"
        class="character"
        :src="getLevelImageSrc(accessedMemberInfo.level,'')"
        :alt="`${accessedMemberInfo.level}`"
      >
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';
import useMapStore from '@/store/storeMap';
import useMemberStore from '@/store/storeMember';


const { isSatelliteInfo } = storeToRefs(useCommonStore());
const {
  satelliteTleData,
  getCountry,
  executeApiOnSchedule,
  getSatelliteName,
  getCoordinate,
  satelliteInfo,
  getSatelliteDataApi,
} = useMapStore();
const { accessedMemberInfo, getLevelImageSrc, getLevelName } = useMemberStore();

/**
 * 현재 위치를 확인하는 초기 동작입니다.
 */
watch(satelliteTleData, () => {
  getCountry();
});

/**
 * 5초마다 한번씩 현재 위치를 확인합니다.
 */
onMounted(async () => {
  await getSatelliteDataApi();

  const intervalId = setInterval(() => {
    getCountry();
    executeApiOnSchedule();
  }, 5000);

  if (satelliteTleData.trackingTables.length === 0) {
    clearInterval(intervalId);
  }
});

/**
 * 실시간 지역 이름을 가져옵니다.
 */
const getCountryName = computed((): string => {
  return satelliteInfo.locationName === ''
    ? '찾는중'
    : `In ${satelliteInfo.locationName}`;
});
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.info_box {
  min-width: 250px;
  height: 100px;
  padding: 15px 16.4px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(56, 56, 56, 0.4) 72%, rgba(82, 82, 82, 0.3) 100%);
  border: 1px solid $color-debra;
  border-bottom-width: 2px;
  color: $color-debra;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  left: 50%;
  bottom: 18%;
  transform: translate(-50%, -50%);
  z-index: 100;

  &_title {
    text-align: center;
    font-family: "Montserrat black 900", sans-serif;
    font-size: 18px;
  }

  .satellite_info_box {
    text-align: center;
    font-family: "Pretendard SemiBold 600", sans-serif;
    line-height: 1.1;
    font-size: 10px;
    margin-bottom: 4px;
  }

  .area_info_list {
    font-size: 12px;
    font-family: "Pretendard Light 300", sans-serif;

    > div {
      display: flex;
      justify-content: space-around;
      white-space: nowrap;
    }

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 0.1px;
      background: rgba(255, 255, 255, 0.2);
      margin: 8px 0;
    }
  }

  .character {
    height: calc(100% + 3px);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &.user {
    width: auto;
    padding-left: 51.5px;

    .info_box_title {
      font-size: 12px;
    }

    .satellite_info_box {
      font-size: 18px;
      white-space: nowrap;
    }
  }
}

.tracking_mode {
  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 70%;
    background: $color-debra;
    position: absolute;
    top: -70%;
    left: 50%;
    transform: translateX(-50%);
  }

  &::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: $color-debra;
    position: absolute;
    top: -70%;
    left: 50%;
    transform: translateX(-50%);
  }
}

// mobile 세로 모드
@media screen and (min-width: 250px) and (max-width: 499px) and (min-height: 450px) {
  .layout {
    .layout_inner_wrap {
      .layout_inner {
        .info_box {
          &.user {
            left: 50%;
            padding-left: 16.4px;
          }

          .character {
            height: calc(100% - 15px);
            top: -30%;
            left: 50%;
          }
        }
      }
    }
  }
}
</style>
